import React, { useEffect, useMemo } from 'react';
import { useDocuments, usePolicyInfo } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { getLatestRenewalNumbers } from 'utils';

import { Navigate } from 'react-router-dom';

import { PrincipalMemberProps } from 'contexts/claimProperties';

import { RequireAuth } from 'auth/RequireAuth';

function ClaimSettlementNoticeDocument() {
  const { keycloak } = useKeycloakReady();
  // const [searchParams] = useSearchParams();
  const fileName = location.pathname.split('/').pop();

  // const [claimSettlementNoticeFileName, setClaimSettlementNoticeFilename] = React.useState('');

  const { shouldFetch: policyShouldFetch, data: policyInfoData } = usePolicyInfo('usePolicyInfo', keycloak.token || '');

  const tokenParsed = keycloak.tokenParsed as PrincipalMemberProps;

  const memberType = tokenParsed ? tokenParsed.memberType : '';

  const renewalNumbers = useMemo(() => {
    return policyInfoData ? getLatestRenewalNumbers(policyInfoData, memberType) : [];
  }, [policyInfoData, memberType]);

  const { shouldFetch: documentsShouldFetch, data: documentsData } = useDocuments(
    { name: 'useDocuments', params: { renewalNumbers } },
    keycloak.token || '',
    renewalNumbers,
  );

  useEffect(() => {
    policyShouldFetch(!!keycloak.authenticated && !!keycloak.token);
    documentsShouldFetch(!!keycloak.authenticated && !!keycloak.token && renewalNumbers.length > 0);
  }, [renewalNumbers, documentsShouldFetch, policyShouldFetch, keycloak]);

  // useEffect(() => {
  //   const fileName = searchParams.get('eob');
  //   setClaimSettlementNoticeFilename(fileName ?? '');
  // }, [searchParams]);

  const claimSettlementNotices = documentsData?.claimSettlementNotice ?? [];
  if (documentsData) {
    if (claimSettlementNotices.length > 0) {
      claimSettlementNotices.map((file) => {
        if (file.name === fileName || file.name?.startsWith(fileName + '.')) {
          if (file.url && file.url !== '') {
            return window.location.replace(file.url || '');
          }
        }
      });
    }
    return (
      <Navigate
        to="/home"
        state={{ fileNotFound: !claimSettlementNotices.some((file) => file.name === fileName) }}
        replace
      />
    );
  }

  return (
    <>
      <RequireAuth />
    </>
  );
}

export default ClaimSettlementNoticeDocument;
